import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import StarIcon from '../../atoms/icons/StarIcon'
import { brandOrange } from '../../../assets/consts/color'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  p {
    line-height: 0;
  }
`

const RatingItemButton = styled.div`
  padding: 0;
  border: none;
  background-color: transparent;
  transition:
    color,
    transform 0.25s ease-in-out,
    color 0.25s ease-in-out;

  color: ${({ filled }) => (filled ? brandOrange : '#D9D9D9')};

  &:hover {
    cursor: pointer;
    transform: scale(1.2);
    background-color: transparent;
  }
`

function SetRatingComponent({ ratingValue, onSetRating }) {
  const handleRatingButtonClick = (rating) => onSetRating(rating)

  return (
    <Container>
      <TypographyAtom type="P" weight="Regular" copy="Your review" />
      <div className="flex">
        {Array(5)
          .fill(null)
          .map((_, index) => (
            <RatingItemButton
              key={index}
              filled={index + 1 <= ratingValue}
              onClick={() => handleRatingButtonClick(index + 1)}
            >
              <StarIcon />
            </RatingItemButton>
          ))}
      </div>
    </Container>
  )
}

export default SetRatingComponent
